// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-history-indicators {
  display: flex;
  flex-direction: column;
}
.match-history-indicators .status-components-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
}
.match-history-indicators .status-components-wrapper .status-component .status-title .status-count {
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/MatchComponents/MatchHistory/MatchHistoryStatusSection/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACJ;AAGQ;EACE,gBAAA;AADV","sourcesContent":[".match-history-indicators {\n  display: flex;\n  flex-direction: column;\n\n  .status-components-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n\n    .status-component {\n      .status-title {\n        .status-count {\n          font-weight: 700;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
